import _ from 'lodash'
import _startsWith from 'lodash/startsWith'
import { get, writable, derived } from 'svelte/store'

export const Pathname = writable( location.pathname )
export const Search = writable( location.search )
export const Hash = writable( location.hash )

export const Resource = writable( 
  get( Pathname ) + get( Search ) + get( Hash )
)

export const setParameter = ( parameter, value ) => {
  let parameters = extractParameters( get( Resource ) )
  parameters[ parameter ] = value
  Search.set( `?${ ( new URLSearchParams( parameters ) ).toString() }` )
}

Pathname.subscribe( _Pathname => {
  Resource.set( _Pathname + get( Search ) + get( Hash ) )
} )

Search.subscribe( _Search => {
  Resource.set( get( Pathname ) + _Search + get( Hash ) )
} )

Hash.subscribe( _Hash => {
  Resource.set( get( Pathname ) + get( Search ) + _Hash )
} )

export const Path = derived( 
  Resource, 
  $Resource => ( extractPath( $Resource ) )
)

export const Query = derived(
  Resource,
  $Resource => ( extractQuery( $Resource ) )
)

export const Parameters = derived(
  Resource,
  $Resource => ( extractParameters( $Resource ) )
)

export const Fragment = derived( 
  Resource,
  $Resource => ( extractFragment( $Resource ) )
)

export const Values = writable( {} )

export const extractPath = resource => {
  return resource.split( '?' )[ 0 ] === '/'
    ? '/'
    : _.trimEnd( resource.split( '?' )[ 0 ], '/' )
}

export const extractQuery = resource => {
  let query = resource.split( '?' )[ 1 ] || ''

  if ( query ) {
    return query.split( '#' )[ 0 ] || ''
  }

  return query
}

export const extractParameters = resource => {
  return Object.fromEntries( new URLSearchParams( 
    extractQuery( resource )
  ) ) 
}

export const extractFragment = resource => {
  return resource.split( '#' )[ 1 ] || ''
}

export const navigate = url => {
  Resource.set( url )
}

export const navigateOffsite = url => {
  window.open( url, '_blank' )
}
